import React, { useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  Tooltip,
  Button,
  FormControl,
  InputLabel,
  Input,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ChatVisual from "./ChatVisual.Component";

const DEFAULT_CHAT_SETTINGS = {
  chatTitle: "",
  chatTitleImg: "",
  chatColor: "#4E8CFF",
  size: "Small",
  url: "",
  launcherCloseIcon: true,
};

const ChatTab = ({
  userPermissionsProps,
  saveChatConfig,
  chatSettingsProps,
}) => {
  const { t } = useTranslation("personalization");
  const [userPermissions] = React.useState(userPermissionsProps);
  const [chatSettings, setChatSettings] = React.useState({ ...DEFAULT_CHAT_SETTINGS});

  useEffect(() => {
    setChatSettings({
      ...DEFAULT_CHAT_SETTINGS,
      ...chatSettingsProps,
    });
  }, [chatSettingsProps]);

  const handleSaveChat = () => {
    saveChatConfig({     
      ...chatSettingsProps,
      chatTitle: chatSettings.chatTitle || "",
      chatTitleImg: chatSettings.chatTitleImg || "",
      chatColor: chatSettings.chatColor || "#4E8CFF",
      size: chatSettingsProps.size || "Small",
      url: chatSettingsProps.url || "",
      launcherCloseIcon: chatSettingsProps.launcherCloseIcon !== undefined ? chatSettingsProps.launcherCloseIcon : true,
    });
  };

  return (
    <Container>
      <Paper style={{ marginBottom: "10px" }}>
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <h1 style={{ marginTop: "10px" }}>{t("chatCustomization")}</h1>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              width: "100%",
            }}>
            <Box>
              <ChatVisual 
                title={chatSettings.chatTitle || ""} 
                titleImg={chatSettings.chatTitleImg || ""}
                chatColor={chatSettings.chatColor || "#4E8CFF"}
                userPermissions={userPermissions}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <h3>{t("options")}</h3>
              <Tooltip title={userPermissions ? "" : t("noPermissionTooltip")}>
                <FormControl style={{ marginBottom: "1rem", width: "100%" }}>
                  <InputLabel id="chat-title-input">{t("chatTitle")}</InputLabel>
                  <Input
                    id="visual-chat-title-input"
                    fullWidth
                    value={chatSettings.chatTitle || ""}
                    labelId="chat-title-input"
                    style={{ minWidth: "80%" }}
                    disabled={!userPermissions}
                    onChange={(e) =>
                      setChatSettings((prevSettings) => ({
                        ...prevSettings,
                        chatTitle: e.target.value,
                      }))
                    }
                  />
                </FormControl>
              </Tooltip>
              <Tooltip title={userPermissions ? "" : t("noPermissionTooltip")}>
                <FormControl style={{ marginBottom: "1rem", width: "100%" }}>
                  <InputLabel id="chat-title-img-input">{t("chatTitleImg")}</InputLabel>
                  <Input
                    id="visual-chat-title-img-input"
                    fullWidth
                    value={chatSettings.chatTitleImg || ""}
                    labelId="chat-title-img-input"
                    style={{ minWidth: "80%" }}
                    disabled={!userPermissions}
                    onChange={(e) =>
                      setChatSettings((prevSettings) => ({
                        ...prevSettings,
                        chatTitleImg: e.target.value,
                      }))
                    }
                  />
                </FormControl>
              </Tooltip>
              <Tooltip title={userPermissions ? "" : t("noPermissionTooltip")}>
                <FormControl style={{ marginBottom: "1rem", width: "100%" }}>
                  <InputLabel id="chat-color-input" shrink>{t("chatColor")}</InputLabel>
                  <Box sx={{ mt: 3, width: "100%" }}>
                    <input
                      id="visual-chat-color-input"
                      type="color"
                      value={chatSettings.chatColor || "#4E8CFF"}
                      onChange={(e) =>
                        setChatSettings((prevSettings) => ({
                          ...prevSettings,
                          chatColor: e.target.value,
                        }))
                      }
                      disabled={!userPermissions}
                      style={{ width: "100%", height: "40px", cursor: userPermissions ? "pointer" : "arrow" }}
                    />
                  </Box>
                </FormControl>
              </Tooltip>
            </Box>
          </div>
          <Box
            style={{
              display: "flex",
              justifyContent: "flex-end",
              margin: "1rem",
              marginBottom: "1rem",
            }}>
            <Tooltip title={userPermissions ? "" : t("noPermissionTooltip")}>
              <span>
                <Button
                  id="visual-chat-save-button"
                  variant="contained"
                  color="primary"
                  style={{ marginBottom: "1rem" }}
                  onClick={() => handleSaveChat()}
                  disabled={!userPermissions}>
                  {t("save")}
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

ChatTab.propTypes = {
  userPermissionsProps: PropTypes.bool.isRequired,
  saveChatConfig: PropTypes.func.isRequired,
  chatSettingsProps: PropTypes.object.isRequired,
};

export default ChatTab;
